import {Navigate} from 'react-router-dom'
import {CLIENT_PORTAL_PATH} from 'constants/path'
import AppLayout from 'layouts/AppLayout'
import ClientPortal from 'pages/authenticated/ClientPortal'
import ClientPortalLayout from 'layouts/ClientPortal.layout'

const clientPortalRoutesWithAppLayout = [
  {
    element: <AppLayout />,
    children: [
      {
        element: <ClientPortal />,
        children: [
          {
            element: <ClientPortalLayout />,
            children: [
              {
                index: true,
                element: <Navigate to={CLIENT_PORTAL_PATH.ANNOUNCEMENTS} />,
              },
              {
                path: CLIENT_PORTAL_PATH.ANNOUNCEMENTS,
                handle: {title: 'Announcements'},
                lazy: () => import('components/pages/ClientPortal/Announcements'),
              },
              {
                path: CLIENT_PORTAL_PATH.CUSTOMIZATION,
                handle: {title: 'Customization'},
                lazy: () => import('components/pages/ClientPortal/Customization'),
              },
              {
                path: CLIENT_PORTAL_PATH.GENERAL,
                handle: {title: 'General'},
                lazy: () => import('components/pages/ClientPortal/General'),
              },
              {
                path: CLIENT_PORTAL_PATH.TICKETS,
                handle: {title: 'Tickets'},
                lazy: () => import('components/pages/ClientPortal/Tickets'),
              },
            ],
          },
        ],
      },
    ],
  },
]

const clientPortalWithoutAppLayout = [
  {
    path: `/${CLIENT_PORTAL_PATH.PREFIX}/${CLIENT_PORTAL_PATH.ANNOUNCEMENTS}/create`,
    lazy: () => import('components/pages/ClientPortal/AnnouncementDetails'),
    handle: {
      title: 'Create Announcement',
      feature_key: {
        category: 'advanceFeatures',
        type: 'clientPortal',
      },
      permission_key: {
        category: 'client_portal',
        type: 'manage_announcements',
      },
      fallbackRoute: `/${CLIENT_PORTAL_PATH.PREFIX}/${CLIENT_PORTAL_PATH.ANNOUNCEMENTS}`,
    },
  },
  {
    path: `/${CLIENT_PORTAL_PATH.PREFIX}/${CLIENT_PORTAL_PATH.ANNOUNCEMENTS}/edit/:id`,
    lazy: () => import('components/pages/ClientPortal/AnnouncementDetails'),
    handle: {
      title: 'Announcement Details',
      feature_key: {
        category: 'advanceFeatures',
        type: 'clientPortal',
      },
      fallbackRoute: `/${CLIENT_PORTAL_PATH.PREFIX}/${CLIENT_PORTAL_PATH.ANNOUNCEMENTS}`,
    },
  },
]

const clientPortalRoutes = [
  {
    path: CLIENT_PORTAL_PATH.PREFIX,
    handle: {title: 'Client Portal'},
    children: [...clientPortalRoutesWithAppLayout, ...clientPortalWithoutAppLayout],
  },
]

export default clientPortalRoutes
